import { defaultProductPlanDto, ProductPlanDto } from "src/dtos/productPlan/productPlanDto";

/**
 * 화면 행 DTO는 생산계획 공통 DTO의 월·사업장·품목·수량 필드를 그대로 사용한다.
 * 아래 세 필드는 백엔드가 계획과 실적을 병합하면서 계산하거나 판정한 화면 전용 값이다.
 */
export interface PRD1020_R01Dto extends ProductPlanDto {
	/** 행별 생산실적률. 백엔드에서 소수점 한 자리 기준으로 계산한다. */
	achievementRate: number;
	/** 실제 생산계획 존재 여부. 계획이 없는 행의 planQty 0과 데이터 부재를 구분한다. */
	hasPlan: boolean;
	/** 실제 생산실적 존재 여부. 실적이 없는 행의 resultQty 0과 데이터 부재를 구분한다. */
	hasResult: boolean;
}

/** 공통 Grid 초기행과 응답 누락 필드를 보완할 때 사용하는 안전한 기본값이다. */
export const defaultPRD1020_R01Dto: PRD1020_R01Dto = {
	...defaultProductPlanDto,
	achievementRate: 0,
	hasPlan: false,
	hasResult: false,
};
